import {
  Component,
  OnInit,
  inject,
  CUSTOM_ELEMENTS_SCHEMA,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { LoadingService } from "../../services/loading.service";

@Component({
  selector: "app-loading-spinner",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./loading-spinner.component.html",
  styleUrl: "./loading-spinner.component.scss",
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LoadingSpinnerComponent implements OnInit {
  loadingService = inject(LoadingService);

  ngOnInit(): void {
    this.registerLoader();
  }

  private async registerLoader(): Promise<void> {
    const { ring } = await import("ldrs");
    ring.register();
  }
}
